import { FormattedMessage } from 'react-intl';

import { PremiumTagShell } from './premium-tag-shell';
import shellStyle from './premium-tag-shell.module.css';
import tiktokLogo from './tiktok-logo.svg';
import { TIKTOK_COLOR } from './tiktok-constants';
import { messages } from './messages';

export const TikTokExpressShippingTag = () => {
  return (
    <PremiumTagShell color={TIKTOK_COLOR} logo={<img alt='' className={shellStyle['tag-logo']} src={tiktokLogo} />}>
      <FormattedMessage {...messages.tiktokExpressShippingLabel} />
    </PremiumTagShell>
  );
};
